<template>
  <div
    class="absolute max-h-[80vh] h-full max-w-[1124px] mx-auto px-4 top-[74px] right-0 size-full !font-normal"
    v-show="props.isOpen"
  >
    <div
      class="card !w-full !max-w-[1124px] ml-auto bg-white dark:bg-[#3f1f56c3] !backdrop-blur-2xl !rounded-[32px] border border-[#9857C81A] overflow-hidden"
    >
      <div class="flex max-h-[80vh]">
        <ul class="w-[336px] bg-[#F0E5FF] dark:!bg-[#6B259E33] p-8 space-y-2 overflow-y-auto no-scrollbar">
          <li v-for="item in items" :key="item.label">
            <NuxtLink
              :to="item.link"
              @mouseenter="selectedRootItem = item"
              :class="[
                'flex items-center cursor-pointer px-4 py-2 mb-2 overflow-hidden relative rounded-full text-[#9A4EFF] dark:text-[#BD8DFD]',
                item === selectedRootItem
                  ? 'bg-white dark:bg-[#FFFFFF0D] font-medium dark:font-semibold text-black dark:text-white'
                  : '',
              ]"
            >
              <!-- <component :is="item.icon" class="mr-4" /> -->
              <WrSVGIcon :name="item.icon" class="mr-4 size-6" />
              <span>{{ item.label }}</span>
            </NuxtLink>
          </li>
        </ul>
        {{ items.item }}

        <!-- {{ selectedRootItem.items[0][0].items[0].content }} -->
        <div
          class="flex-1 bg-white dark:bg-[#8442B41A] dark:text-white/80 size-full px-8 pt-6 pb-16 overflow-y-auto flex flex-col max-h-[80vh] min-h-[600px] h-full"
        >
          <WrMenuContent
            v-if="selectedRootItem"
            :items="selectedRootItem.items[0][0].items[0].content"
            :variant="selectedRootItem.items[0][0].items[0].variant"
            :link="selectedRootItem.items[0][0].items[0].link"
            class="h-full dark:text-white/80"
            @close="handleClose"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { defineAsyncComponent } from "vue";

const WrMenuContent = defineAsyncComponent(
  () => import("~/components/molecules/WrMenuContent.vue"),
);

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["closeMegamenu"]);

const handleClose = () => {
  emit("closeMegamenu");
  selectedRootItem.value = items.value[0];
};

const selectedRootItem = ref(null);

onMounted(() => {
  if (items.value.length) {
    selectedRootItem.value = items.value[0];
  }
});

const preventScroll = () => {
  document.body.style.overflow = "hidden";
};

const allowScroll = () => {
  document.body.style.overflow = "";
};

const items = ref([
  {
    label: "Design",
    link: "/services/design",
    icon: "WrDesign",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              content: [
                {
                  items: [
                    {
                      label: "Design System",
                      icon: "WrDesignSystem",
                      item: "design-system",
                      link: "/services/design/design-system",
                    },
                    {
                      label: "Brand Identity Design",
                      icon: "WrBrandIdentity",
                      item: "brand-identity-design",
                      link: "/services/design/brand-identity-design",
                    },
                    {
                      label: "UI/UX & Website Design",
                      icon: "WrUiUxWebsite",
                      item: "ui-ux-website-design",
                      link: "/services/design/ui-ux-website-design",
                    },
                    {
                      label: "Design Thinking",
                      icon: "WrDesignThinking",
                      item: "design-thinking",
                      link: "/services/design/design-thinking",
                    },
                    {
                      label: "Social Media Creative",
                      icon: "WrSocialMediaCreative",
                      item: "social-media-creative",
                      link: "/services/design/social-media-creative",
                    },
                    {
                      label: "Mobile App Design",
                      icon: "WrMobileAppDesign",
                      item: "mobile-app-design",
                      link: "/services/design/mobile-app-design",
                    },
                    {
                      label: "Illustration Design",
                      icon: "WrIllustrationDesign",
                      item: "illustration-design",
                      link: "/services/design/illustration-design",
                    },
                    {
                      label: "Email Design",
                      icon: "WrEmailDesign",
                      item: "email-design",
                      link: "/services/design/email-design",
                    },
                    {
                      label: "Animation/Motion Graphics",
                      icon: "WrAnimationMotion",
                      item: "animation-motion-graphics",
                      link: "/services/design/animation-motion-graphics",
                    },
                    {
                      label: "Video Production",
                      icon: "WrVideoProduction",
                      item: "video-production",
                      link: "/services/design/video-production",
                    },
                    {
                      label: "Concept Creation",
                      icon: "WrConceptCreation",
                      item: "concept-creation",
                      link: "/services/design/concept-creation",
                    },
                    {
                      label: "eBook & Digital Report Design",
                      icon: "WrEbookDigitalReport",
                      item: "ebook-digital-report-design",
                      link: "/services/design/ebook-digital-report-design",
                    },
                    {
                      label: "Logo Design",
                      icon: "WrLogoDesign",
                      item: "logo-design",
                      link: "/services/design/logo-design",
                    },
                    {
                      label: "Print Design",
                      icon: "WrPrintDesign",
                      item: "print-design",
                      link: "/services/design/print-design",
                    },
                    {
                      label: "Packaging & Merch Design",
                      icon: "WrPackagingMerch",
                      item: "packaging-merch-design",
                      link: "/services/design/packaging-merch-design",
                    },
                    {
                      label: "AI - Enhanced Creative",
                      icon: "WrAiEnhancedCreative",
                      item: "ai-enhanced-creative",
                      link: "/services/design/ai-enhanced-creative",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Development Services",
    link: "/services/development-services",
    icon: "WrDevelopment",
    root: true,
    items: [
      [
        {
          items: [
            {
              content: [
                {
                  items: [
                    {
                      label: "AI Machine Learning Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-machine-learning-services",
                      link: "/services/development-services/ai-machine-learning-services",
                    },
                    {
                      label: "API Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "api-development",
                      link: "/services/development-services/api-development",
                    },
                    {
                      label: "Application Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "application-development",
                      link: "/services/development-services/application-development",
                    },
                    {
                      label: "Application Maintenance & Support",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "application-maintenance-support",
                      link: "/services/development-services/application-maintenance-support",
                    },
                    {
                      label: "Automated Testing Service",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "automated-testing-service",
                      link: "/services/development-services/automated-testing-service",
                    },
                    {
                      label: "Automation Testing",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "automation-testing",
                      link: "/services/development-services/automation-testing",
                    },
                    {
                      label: "AWS Cloud & Migration Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "aws-cloud-and-migration-services",
                      link: "/services/development-services/aws-cloud-and-migration-services",
                    },
                    {
                      label: "Blockchain Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "blockchain-development",
                      link: "/services/development-services/blockchain-development",
                    },
                    {
                      label: "Business Automation",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "business-automation",
                      link: "/services/development-services/business-automation",
                    },
                    {
                      label: "Chatbot Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "chatbot-development",
                      link: "/services/development-services/chatbot-development",
                    },
                    {
                      label: "CMS Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "cms-development",
                      link: "/services/development-services/cms-development",
                    },
                    {
                      label: "Dedicated Development Team",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "dedicated-development-team",
                      link: "/services/development-services/dedicated-development-team",
                    },
                    {
                      label: "Desktop Software Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "desktop-software-development",
                      link: "/services/development-services/desktop-software-development",
                    },
                    {
                      label: "DevOps Solutions",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "devops-solutions",
                      link: "/services/development-services/devops-solutions",
                    },
                    {
                      label: "Docker Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "docker-development",
                      link: "/services/development-services/docker-development",
                    },
                    {
                      label: "Ecommerce Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ecommerce-development",
                      link: "/services/development-services/ecommerce-development",
                    },
                    {
                      label: "FinTech Product Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "finTech-product-development",
                      link: "/services/development-services/finTech-product-development",
                    },
                    {
                      label: "FusionCharts Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "fusioncharts-development",
                      link: "/services/development-services/fusioncharts-development",
                    },
                    {
                      label: "IoT Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "iot-development",
                      link: "/services/development-services/iot-development",
                    },
                    {
                      label: "IT Consulting",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "it-consulting",
                      link: "/services/development-services/it-consulting",
                    },
                    {
                      label: "Kubernetes Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "kubernetes-development",
                      link: "/services/development-services/kubernetes-development",
                    },
                    {
                      label: "Mobile App Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "mobile-app-development",
                      link: "/services/development-services/mobile-app-development",
                    },
                    {
                      label: "Multi-Tenant SaaS Product Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "multi-tenant-saas-product-development",
                      link: "/services/development-services/multi-tenant-saas-product-development",
                    },
                    {
                      label: "MVP Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "mvp-development",
                      link: "/services/development-services/mvp-development",
                    },
                    {
                      label: "NFT Token Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "nft-token-development",
                      link: "/services/development-services/nft-token-development",
                    },
                    {
                      label: "POC Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "poc-development",
                      link: "/services/development-services/poc-development",
                    },
                    {
                      label: "Product Engineering",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "product-engineering",
                      link: "/services/development-services/product-engineering",
                    },
                    {
                      label: "SaaS Product Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "saas-product-development",
                      link: "/services/development-services/saas-product-development",
                    },
                    {
                      label: "Software Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "software-development",
                      link: "/services/development-services/software-development",
                    },
                    {
                      label: "Website Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "website-development",
                      link: "/services/development-services/website-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Technologies/Languages",
    link: "/services/languages",
    icon: "WrSettings",
    root: true,
    items: [
      [
        {
          items: [
            {
              content: [
                {
                  items: [
                    {
                      label: "PHP",
                      iconPosition: "bg-[position:-73px_0px]",
                      item: "php",
                      link: "/services/languages/php-development-services",
                    },
                    {
                      label: ".NET",
                      iconPosition: "bg-[position:-73px_-48px]",
                      item: ".net",
                      link: "/services/languages/dot-net-development-services",
                    },
                    {
                      label: "Java",
                      iconPosition: "bg-[position:-73px_-96px]",
                      item: "java",
                      link: "/services/languages/java-development-services",
                    },
                    {
                      label: "Java Script",
                      iconPosition: "bg-[position:-73px_-144px]",
                      item: "javascript",
                      link: "/services/languages/javascript-development-services",
                    },
                    {
                      label: "Python",
                      iconPosition: "bg-[position:-73px_-192px]",
                      item: "python",
                      link: "/services/languages/python-development-services",
                    },
                    {
                      label: "Node",
                      iconPosition: "bg-[position:-73px_-384px]",
                      item: "node-js",
                      link: "/services/languages/nodejs-development-services",
                    },
                    {
                      label: "Mean Stack",
                      iconPosition: "bg-[position:-73px_-432px]",
                      item: "mean-stack",
                      link: "/services/languages/mean-stack-development-services",
                    },
                    {
                      label: "Ruby",
                      iconPosition: "bg-[position:-73px_-480px]",
                      item: "ruby",
                      link: "/services/languages/ruby-development-services",
                    },
                    {
                      label: "SharePoint",
                      iconPosition: "bg-[position:-73px_-528px]",
                      item: "sharepoint",
                      link: "/services/languages/sharepoint-development-services",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Frameworks",
    link: "/services/frameworks",
    icon: "WrFrameworks",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              variant: "frameworks",
              link: "/services/frameworks",
              content: [
                {
                  label: "Backend",
                  items: [
                    {
                      label: "Laravel",
                      iconPosition: "bg-[position:-146px_-144px]",
                      item: "laravel",
                      link: "/services/frameworks/laravel-development-services",
                    },
                    {
                      label: "Express",
                      iconPosition: "bg-[position:-146px_0px]",
                      item: "express",
                      link: "/services/frameworks/express-development-services",
                    },
                    {
                      label: "Django",
                      iconPosition: "bg-[position:-146px_-48px]",
                      item: "django",
                      link: "/services/frameworks/django-development-services",
                    },
                    {
                      label: "Spring",
                      iconPosition: "bg-[position:-146px_-192px]",
                      item: "spring",
                      link: "/services/frameworks/spring-development-services",
                    },
                    {
                      label: "Adonis",
                      iconPosition: "bg-[position:-146px_-240px]",
                      item: "adonisjs",
                      link: "/services/frameworks/adonisjs-development-services",
                    },
                    {
                      label: "CodeIgnitor",
                      iconPosition: "bg-[position:-146px_-288px]",
                      item: "codeignitor",
                      link: "/services/frameworks/codeignitor-development-services",
                    },
                    {
                      label: "CakePHP",
                      iconPosition: "bg-[position:-146px_-336px]",
                      item: "cakephp",
                      link: "/services/frameworks/cakephp-development-services",
                    },
                    {
                      label: "Sails",
                      iconPosition: "bg-[position:-146px_-384px]",
                      item: "sails-js",
                      link: "/services/frameworks/sails-js-development-services",
                    },
                    {
                      label: "Yii",
                      iconPosition: "bg-[position:-146px_-432px]",
                      item: "yii",
                      link: "/services/frameworks/yii-development-services",
                    },
                    {
                      label: "Meteor",
                      iconPosition: "bg-[position:-146px_-480px]",
                      item: "meteor",
                      link: "/services/frameworks/meteor-development-services",
                    },
                    {
                      label: "Symfony",
                      iconPosition: "bg-[position:-146px_-528px]",
                      item: "symfony",
                      link: "/services/frameworks/symfony-development-services",
                    },
                    {
                      label: "Ruby on Rails",
                      iconPosition: "bg-[position:-146px_-576px]",
                      item: "ruby-on-rails",
                      link: "/services/frameworks/ruby-on-rails-development-services",
                    },
                    {
                      label: "Flask",
                      iconPosition: "bg-[position:-146px_-624px]",
                      item: "flask",
                      link: "/services/frameworks/flask-development-services",
                    },
                    {
                      label: "Pyramid",
                      iconPosition: "bg-[position:-146px_-672px]",
                      item: "pyramid",
                      link: "/services/frameworks/pyramid-development-services",
                    },
                    {
                      label: "Hadoop",
                      iconPosition: "bg-[position:-146px_-720px]",
                      item: "hadoop",
                      link: "/services/frameworks/hadoop-development-services",
                    },
                    {
                      label: "WebdriverIO ",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "webdriverIO",
                      link: "/services/frameworks/webdriverio-testing-services",
                    },
                  ],
                },
                {
                  label: "Frontend",
                  appendClass: "*:w-full shrink",
                  items: [
                    {
                      label: "Vue",
                      iconPosition: "bg-[position:-219px_0px]",
                      item: "vuejs",
                      link: "/services/frameworks/vuejs-development-services",
                    },
                    {
                      label: "Nuxt",
                      iconPosition: "bg-[position:-219px_-48px]",
                      item: "nuxtjs",
                      link: "/services/frameworks/nuxtjs-development-services",
                    },
                    {
                      label: "React",
                      iconPosition: "bg-[position:-219px_-96px]",
                      item: "reactjs",
                      link: "/services/frameworks/reactjs-development-services",
                    },
                    {
                      label: "Angular",
                      iconPosition: "bg-[position:-219px_-144px]",
                      item: "angularjs",
                      link: "/services/frameworks/angularjs-development-services",
                    },
                    {
                      label: "Ember",
                      iconPosition: "bg-[position:-219px_-192px]",
                      item: "ember",
                      link: "/services/frameworks/ember-development-services",
                    },
                    {
                      label: "Backbone",
                      iconPosition: "bg-[position:-219px_-240px]",
                      item: "backbone",
                      link: "/services/frameworks/backbone-development-services",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "CMS",
    link: "/services/cms-development",
    icon: "WrFolder",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              variant: "cms",
              link: "/cms",
              content: [
                {
                  appendClass: "*:w-1/3 shrink",
                  items: [
                    {
                      label: "Vaah<b>Cms</b>",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "vaahcms",
                      link: "/services/cms-development/vaahcms-development",
                    },
                    {
                      label: "WordPress",
                      iconPosition: "bg-[position:-292px_0px]",
                      item: "wordpress",
                      link: "/services/cms-development/wordpress-development",
                    },
                    {
                      label: "Drupal",
                      iconPosition: "bg-[position:-292px_-49px]",
                      item: "drupal",
                      link: "/services/cms-development/drupal-development",
                    },
                    {
                      label: "Magento",
                      iconPosition: "bg-[position:-292px_-98px]",
                      item: "magento",
                      link: "/services/cms-development/magento-development",
                    },
                    {
                      label: "Joomla",
                      iconPosition: "bg-[position:-292px_-147px]",
                      item: "joomla",
                      link: "/services/cms-development/joomla-development",
                    },
                    {
                      label: "Shopify",
                      iconPosition: "bg-[position:-292px_-196px]",
                      item: "shopify",
                      link: "/services/cms-development/shopify-development",
                    },
                    {
                      label: "Typo3",
                      iconPosition: "bg-[position:-292px_-245px]",
                      item: "typo3",
                      link: "/services/cms-development/typo3-development",
                    },
                    {
                      label: "Bitrix",
                      iconPosition: "bg-[position:-292px_-294px]",
                      item: "bitrix",
                      link: "/services/cms-development/bitrix-development",
                    },
                    {
                      label: "SquareSpace",
                      iconPosition: "bg-[position:-292px_-343px]",
                      item: "squarespace",
                      link: "/services/cms-development/squarespace-development",
                    },
                    {
                      label: "Prestashop",
                      iconPosition: "bg-[position:-292px_-392px]",
                      item: "prestashop",
                      link: "/services/cms-development/prestashop-development",
                    },
                    {
                      label: "Blogger",
                      iconPosition: "bg-[position:-292px_-441px]",
                      item: "blogger",
                      link: "/services/cms-development/blogger-development",
                    },
                    {
                      label: "vBulletin",
                      iconPosition: "bg-[position:-292px_-490px]",
                      item: "vbulletin",
                      link: "/services/cms-development/vbulletin-development",
                    },
                    {
                      label: "Wix",
                      iconPosition: "bg-[position:-292px_-539px]",
                      item: "wix",
                      link: "/services/cms-development/wix-development",
                    },
                    {
                      label: "Moodle",
                      iconPosition: "bg-[position:-292px_-588px]",
                      item: "moodle",
                      link: "/services/cms-development/moodle-development",
                    },
                    {
                      label: "WooCommerce",
                      iconPosition: "bg-[position:-292px_-637px]",
                      item: "woocommerce",
                      link: "/services/cms-development/woocommerce-development",
                    },
                    {
                      label: "Weebly",
                      iconPosition: "bg-[position:-292px_-686px]",
                      item: "weebly",
                      link: "/services/cms-development/weebly-development",
                    },
                    {
                      label: "ExpressionEngine",
                      iconPosition: "bg-[position:-292px_-735px]",
                      item: "expressionengine",
                      link: "/services/cms-development/expressionengine-development",
                    },
                    {
                      label: "Open Cart",
                      iconPosition: "bg-[position:-292px_-784px]",
                      item: "opencart",
                      link: "/services/cms-development/opencart-development",
                    },
                    {
                      label: "NopCommerce",
                      iconPosition: "bg-[position:-292px_-833px]",
                      item: "nopcommerce",
                      link: "/services/cms-development/nopcommerce-development",
                    },
                    {
                      label: "Umbraco",
                      iconPosition: "bg-[position:-292px_-882px]",
                      item: "umbraco",
                      link: "/services/cms-development/umbraco-development",
                    },
                    {
                      label: "Kentico",
                      iconPosition: "bg-[position:-292px_-931px]",
                      item: "kentico",
                      link: "/services/cms-development/kentico-development",
                    },
                    {
                      label: "Sitecore",
                      iconPosition: "bg-[position:-292px_-980px]",
                      item: "sitecore",
                      link: "/services/cms-development/sitecore-development",
                    },
                    {
                      label: "Keystone",
                      iconPosition: "bg-[position:-292px_-1029px]",
                      item: "keystonejs",
                      link: "/services/cms-development/keystonejs-development",
                    },
                    {
                      label: "Strapi",
                      iconPosition: "bg-[position:-292px_-1078px]",
                      item: "strapi",
                      link: "/services/cms-development/strapi-development",
                    },
                    {
                      label: "Ghost",
                      iconPosition: "bg-[position:-292px_-1127px]",
                      item: "ghost",
                      link: "/services/cms-development/ghost-development",
                    },
                    {
                      label: "LAMP Development",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "lamp",
                      link: "/services/cms-development/lamp-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Mobility/Mobile Apps",
    link: "/services/mobility",
    icon: "WrMobile",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              content: [
                {
                  items: [
                    {
                      label: "Android",
                      iconPosition: "bg-[position:-365px_0px]",
                      item: "android",
                      link: "/services/mobility/android-app-development",
                    },
                    {
                      label: "iOS",
                      iconPosition: "bg-[position:-365px_-49px]",
                      item: "ios",
                      link: "/services/mobility/ios-app-development",
                    },
                    {
                      label: "Hybrid Apps",
                      iconPosition: "bg-[position:-365px_-98px]",
                      item: "hybrid-apps",
                      link: "/services/mobility/hybrid-app-development",
                    },
                    {
                      label: "Xamarin",
                      iconPosition: "bg-[position:-365px_-147px]",
                      item: "xamarin",
                      link: "/services/mobility/xamarin-app-development",
                    },
                    {
                      label: "AR",
                      iconPosition: "bg-[position:-365px_-196px]",
                      item: "ar",
                      link: "/services/mobility/ar-app-development",
                    },
                    {
                      label: "VR",
                      iconPosition: "bg-[position:-365px_-245px]",
                      item: "vr",
                      link: "/services/mobility/vr-app-development",
                    },
                    {
                      label: "ReactNative",
                      iconPosition: "bg-[position:-365px_-294px]",
                      item: "reactnative",
                      link: "/services/mobility/reactnative-app-development",
                    },
                    {
                      label: "Flutter",
                      iconPosition: "bg-[position:-365px_-343px]",
                      item: "flutter",
                      link: "/services/mobility/flutter-app-development",
                    },
                    {
                      label: "NativeScript",
                      iconPosition: "bg-[position:-365px_-392px]",
                      item: "nativescript",
                      link: "/services/mobility/nativescript-app-development",
                    },
                    {
                      label: "Unity",
                      iconPosition: "bg-[position:-365px_-441px]",
                      item: "unity",
                      link: "/services/mobility/unity-app-development",
                    },
                    {
                      label: "Apple Watch App Development",
                      iconPosition: "bg-[position:-365px_-490px]",
                      item: "apple-watch",
                      link: "/services/mobility/apple-watch-app-development",
                    },
                    {
                      label: "Tizen Application Development",
                      iconPosition: "bg-[position:-365px_-539px]",
                      item: "tizen",
                      link: "/services/mobility/tizen-app-development",
                    },
                    {
                      label: "iBeacon App Development Company",
                      iconPosition: "bg-[position:-365px_-588px]",
                      item: "ibeacon",
                      link: "/services/mobility/ibeacon-app-development",
                    },
                    {
                      label: "PhoneGap Development Company",
                      iconPosition: "bg-[position:-365px_-637px]",
                      item: "phonegap",
                      link: "/services/mobility/phonegap-app-development",
                    },
                    {
                      label: "Ionic Framework",
                      iconPosition: "bg-[position:-365px_-686px]",
                      item: "ionic",
                      link: "/services/mobility/ionic-app-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Desktop",
    icon: "WrDesktop",
    link: "/services/desktop",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              content: [
                {
                  items: [
                    {
                      label: "Windows Application Development",
                      iconPosition: "bg-[position:-438px_0px]",
                      item: "windows",
                      link: "/services/desktop/windows-software-development",
                    },
                    {
                      label: "MAC Software Development",
                      iconPosition: "bg-[position:-438px_-48px]",
                      item: "mac",
                      link: "/services/desktop/mac-software-development",
                    },
                    {
                      label: "Cocoa Software Framework",
                      iconPosition: "bg-[position:-438px_-96px]",
                      item: "cocoa",
                      link: "/services/desktop/cocoa-software-development",
                    },
                    {
                      label: "Electron Software Development",
                      iconPosition: "bg-[position:-438px_-144px]",
                      item: "electron",
                      link: "/services/desktop/electron-software-development",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Industries",
    icon: "WrIndustries",
    link: "/services/industries",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              content: [
                {
                  items: [
                    {
                      label: "Health Care and Fitness",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-agent-development",
                      link: "/services/industries/health-care-and-fitness",
                    },
                    {
                      label: "Education and Training",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-chatbot-development",
                      link: "/services/industries/education-and-training",
                    },
                    {
                      label: "Retail and eCommerce",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "machine-learning",
                      link: "/services/industries/retail-and-ecommerce",
                    },
                    {
                      label: "Sports and Entertainment",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "deep-learning",
                      link: "/services/industries/sports-and-entertainment",
                    },
                    {
                      label: "Media and Publishing",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "predictive-analysis",
                      link: "/services/industries/media-and-publishing",
                    },
                    {
                      label: "Food and Beverage",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "image-processing",
                      link: "/services/industries/food-and-beverage",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
  {
    label: "Maintenance Services",
    link: "/services/maintenance-services",
    icon: "WrProducts",
    root: true,
    items: [
      [
        {
          items: [
            {
              comp: "WrMenuContent",
              content: [
                {
                  items: [
                    {
                      label: "Laravel Maintenance Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-agent-development",
                      link: "/services/maintenance-services/laravel",
                    },
                    {
                      label: "WordPress Maintenance Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "ai-chatbot-development",
                      link: "/services/maintenance-services/wordpress",
                    },
                    {
                      label: "Mobile App Maintenance Services",
                      iconPosition: "bg-[position:0px_0px]",
                      item: "machine-learning",
                      link: "/services/maintenance-services/mobile-apps",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    ],
  },
]);
</script>
